import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 0,
  class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2"
}
const _hoisted_8 = { class: "col p-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = {
  key: 1,
  class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2"
}
const _hoisted_11 = { class: "col p-0" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = {
  key: 2,
  class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2"
}
const _hoisted_14 = { class: "col p-0" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_17 = { class: "col p-0" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_20 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_21 = { class: "col p-0" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_24 = {
  key: 3,
  class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2"
}
const _hoisted_25 = { class: "col p-0" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_28 = { class: "col p-0" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_31 = { class: "col p-0" }
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_34 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_35 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_36 = { class: "col p-0" }
const _hoisted_37 = { class: "" }
const _hoisted_38 = {
  key: 4,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_39 = { class: "col p-0" }
const _hoisted_40 = { class: "" }
const _hoisted_41 = {
  key: 5,
  class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2"
}
const _hoisted_42 = { class: "col p-0" }
const _hoisted_43 = { class: "" }
const _hoisted_44 = {
  key: 6,
  class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2"
}
const _hoisted_45 = { class: "col p-0" }
const _hoisted_46 = { class: "" }
const _hoisted_47 = {
  key: 7,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_48 = { class: "col p-0" }
const _hoisted_49 = { class: "" }
const _hoisted_50 = {
  key: 8,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_51 = { class: "col p-0" }
const _hoisted_52 = { class: "" }
const _hoisted_53 = ["disabled", "placeholder"]
const _hoisted_54 = {
  key: 9,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_55 = { class: "col p-0" }
const _hoisted_56 = { class: "" }
const _hoisted_57 = ["disabled", "placeholder"]
const _hoisted_58 = {
  key: 10,
  class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_59 = { class: "col p-0" }
const _hoisted_60 = { class: "form-check small mb-0 mt-1" }
const _hoisted_61 = {
  class: "form-check-label",
  for: "onlyProviders"
}
const _hoisted_62 = { class: "form-group mb-2 col" }
const _hoisted_63 = { class: "col-auto p-0 text-end" }
const _hoisted_64 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_65 = {
  key: 0,
  class: "form-group mb-2 col-auto me-2"
}
const _hoisted_66 = { class: "col p-0" }
const _hoisted_67 = { class: "d-flex align-items-center flex-nowrap" }
const _hoisted_68 = { class: "me-2 mb-0" }
const _hoisted_69 = {
  class: "btn btn-sm btn-outline-dark",
  for: "group-stores"
}
const _hoisted_70 = {
  class: "btn btn-sm btn-outline-dark ms-2",
  for: "group-traders"
}
const _hoisted_71 = {
  class: "btn btn-sm btn-outline-dark ms-2",
  for: "group-providers"
}
const _hoisted_72 = {
  key: 1,
  class: "col text-end"
}
const _hoisted_73 = { class: "dropdown d-inline-block" }
const _hoisted_74 = {
  class: "btn btn-outline-primary btn-sm rounded-pill text-capitalize-first dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_75 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = {
  key: 1,
  class: "row"
}
const _hoisted_78 = {
  key: 0,
  class: "form-group mb-2 col-sm-12 me-2"
}
const _hoisted_79 = { class: "col p-0" }
const _hoisted_80 = { class: "" }
const _hoisted_81 = { class: "me-2" }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = { class: "me-2" }
const _hoisted_84 = {
  class: "d-inline-block",
  style: {"width":"200px"}
}
const _hoisted_85 = { class: "me-2 ms-2" }
const _hoisted_86 = {
  class: "d-inline-block",
  style: {"width":"200px"}
}
const _hoisted_87 = { class: "card card-body mb-0" }
const _hoisted_88 = { class: "overflow-auto" }
const _hoisted_89 = { class: "table table-bordered align-middle text-left text-nowrap position-relative" }
const _hoisted_90 = {
  colspan: "20",
  class: "text-center bg-secondary text-white"
}
const _hoisted_91 = {
  key: 0,
  class: "text-center mb-2 text-capitalize"
}
const _hoisted_92 = {
  key: 1,
  class: "text-center mb-2"
}
const _hoisted_93 = {
  key: 2,
  class: "text-center mb-2"
}
const _hoisted_94 = { key: 0 }
const _hoisted_95 = {
  colspan: "20",
  class: "text-center text-capitalize"
}
const _hoisted_96 = { class: "bg-light" }
const _hoisted_97 = {
  rowspan: "2",
  class: "text-capitalize-first",
  style: {"width":"0"}
}
const _hoisted_98 = {
  rowspan: "2",
  class: "text-capitalize-first",
  style: {"width":"0"}
}
const _hoisted_99 = {
  rowspan: "2",
  class: "text-capitalize-first text-wrap",
  style: {"width":"0"}
}
const _hoisted_100 = {
  key: 0,
  rowspan: "2",
  class: "text-capitalize-first text-wrap",
  style: {"width":"0"}
}
const _hoisted_101 = {
  key: 1,
  rowspan: "2",
  class: "text-capitalize-first text-wrap",
  style: {"width":"0"}
}
const _hoisted_102 = {
  key: 2,
  rowspan: "2",
  class: "text-capitalize-first text-wrap",
  style: {"width":"0"}
}
const _hoisted_103 = {
  key: 3,
  rowspan: "2",
  class: "text-capitalize-first text-wrap",
  style: {"width":"0"}
}
const _hoisted_104 = ["colspan"]
const _hoisted_105 = { class: "bg-light" }
const _hoisted_106 = {
  key: 0,
  class: "text-capitalize-first text-center",
  style: {"width":"0"}
}
const _hoisted_107 = {
  key: 1,
  class: "text-capitalize-first text-center",
  style: {"width":"0"}
}
const _hoisted_108 = {
  key: 2,
  class: "text-capitalize-first text-center",
  style: {"width":"0"}
}
const _hoisted_109 = {
  key: 3,
  class: "text-capitalize-first text-center",
  style: {"width":"0"}
}
const _hoisted_110 = {
  class: "text-capitalize-first text-center",
  style: {"width":"0"}
}
const _hoisted_111 = {
  key: 0,
  class: "text-capitalize-first text-center",
  style: {"width":"0"}
}
const _hoisted_112 = { class: "text-end" }
const _hoisted_113 = { class: "text-capitalize-first text-start" }
const _hoisted_114 = { class: "text-start" }
const _hoisted_115 = { key: 0 }
const _hoisted_116 = { key: 1 }
const _hoisted_117 = { key: 2 }
const _hoisted_118 = { key: 3 }
const _hoisted_119 = { key: 0 }
const _hoisted_120 = { key: 1 }
const _hoisted_121 = { key: 2 }
const _hoisted_122 = { key: 3 }
const _hoisted_123 = { key: 0 }
const _hoisted_124 = { key: 4 }
const _hoisted_125 = { key: 0 }
const _hoisted_126 = { key: 5 }
const _hoisted_127 = { key: 0 }
const _hoisted_128 = { key: 6 }
const _hoisted_129 = { key: 0 }
const _hoisted_130 = { key: 7 }
const _hoisted_131 = { key: 0 }
const _hoisted_132 = { key: 1 }
const _hoisted_133 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MerchantMultiselect = _resolveComponent("MerchantMultiselect")!
  const _component_StoreMultiselect = _resolveComponent("StoreMultiselect")!
  const _component_TrafficGroupMultiselect = _resolveComponent("TrafficGroupMultiselect")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_DevicesMultiselect = _resolveComponent("DevicesMultiselect")!
  const _component_TeamLeadMultiselect = _resolveComponent("TeamLeadMultiselect")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _directive_bs_dropdown_fixed = _resolveDirective("bs-dropdown-fixed")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.isAdmin || _ctx.isOperator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_MerchantMultiselect, {
                              multiple: true,
                              modelValue: _ctx.merchantsFilter,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.merchantsFilter) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin || _ctx.isOperator || _ctx.isMerchant || _ctx.isMerchantOperator || _ctx.isReferral)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_StoreMultiselect, {
                              multiple: true,
                              modelValue: _ctx.storesFilter,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.storesFilter) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin || _ctx.isOperator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_TrafficGroupMultiselect, {
                              multiple: true,
                              small: "",
                              modelValue: _ctx.trafficGroupsFilter,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trafficGroupsFilter) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_DatePicker, {
                          modelValue: _ctx.requestDTO.fromDate,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.fromDate) = $event)),
                          mode: "dateTime",
                          "model-modifiers": {string: true},
                          is24hr: "",
                          masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                        }, {
                          default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                            _createElementVNode("input", {
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.from_date'),
                              value: inputValue,
                              onFocus: togglePopover,
                              onChange: inputEvents.change
                            }, null, 40, _hoisted_19)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_DatePicker, {
                          modelValue: _ctx.requestDTO.toDate,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDTO.toDate) = $event)),
                          mode: "dateTime",
                          "model-modifiers": {string: true},
                          is24hr: "",
                          masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                        }, {
                          default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                            _createElementVNode("input", {
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.to_date'),
                              value: inputValue,
                              onFocus: togglePopover,
                              onChange: inputEvents.change
                            }, null, 40, _hoisted_23)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  (_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_TraderMultiselect, {
                              "onUpdate:modelValue": [
                                _ctx.onTraderListUpdate,
                                _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tradersFilter) = $event))
                              ],
                              multiple: true,
                              modelValue: _ctx.tradersFilter
                            }, null, 8, ["onUpdate:modelValue", "modelValue"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_Multiselect, {
                          id: "statuses",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.statuses,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestDTO.statuses) = $event)),
                          options: Object.values(_ctx.DealStatus),
                          "custom-label": (opt) => _ctx.helper.trans(`deal_status.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.statuses')
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_Multiselect, {
                          id: "methods",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.methods,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestDTO.methods) = $event)),
                          options: _ctx.store.getters['currencyMethods/methods'](),
                          "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.payment_methods')
                        }, {
                          option: _withCtx((props) => [
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_component_PayMethodIcon, {
                                "icon-class": "icon",
                                method: props.option
                              }, null, 8, ["method"]),
                              _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_Multiselect, {
                          id: "options",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.options,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestDTO.options) = $event)),
                          options: _ctx.store.getters['currencyMethods/options'](),
                          "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.payment_options')
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  (_ctx.isAdmin || _ctx.isOperator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createVNode(_component_Multiselect, {
                              id: "types",
                              class: "multiselect-sm",
                              modelValue: _ctx.requestDTO.types,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requestDTO.types) = $event)),
                              options: Object.values(_ctx.Direction),
                              "custom-label": (opt) => _ctx.helper.trans(`direction.${opt}`),
                              multiple: true,
                              "select-label": "Select",
                              placeholder: _ctx.helper.trans('labels.type')
                            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin || _ctx.isOperator || (_ctx.isTrader && !_ctx.user.pcId) || _ctx.isTraderOperator )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _createVNode(_component_DevicesMultiselect, {
                              ref: "deviceMultiselect",
                              multiple: true,
                              "trader-ids": _ctx.tradersFilter.map((item) => item.id),
                              modelValue: _ctx.devicesFilter,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.devicesFilter) = $event))
                            }, null, 8, ["trader-ids", "modelValue"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin || _ctx.isOperator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_component_TeamLeadMultiselect, {
                              multiple: false,
                              modelValue: _ctx.teamLeadFilter,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.teamLeadFilter) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin || _ctx.isOperator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createVNode(_component_Multiselect, {
                              id: "currency",
                              class: "multiselect-sm multiselect-capitalize",
                              modelValue: _ctx.requestDTO.currency,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.requestDTO.currency) = $event)),
                              options: _ctx.store.getters['currencyMethods/currencies'],
                              "custom-label": (opt) => opt,
                              multiple: false,
                              "select-label": "Select",
                              placeholder: _ctx.helper.trans('labels.currency')
                            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin || _ctx.isOperator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              disabled: !_ctx.requestDTO.currency,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.requestDTO.amountFrom) = $event)),
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.from_sum')
                            }, null, 8, _hoisted_53), [
                              [_vModelText, _ctx.requestDTO.amountFrom]
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin || _ctx.isOperator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              disabled: !_ctx.requestDTO.currency,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.requestDTO.amountTo) = $event)),
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.to_sum')
                            }, null, 8, _hoisted_57), [
                              [_vModelText, _ctx.requestDTO.amountTo]
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin || _ctx.isOperator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.requestDTO.onlyProviders) = $event)),
                              "true-value": "1",
                              type: "checkbox",
                              value: "",
                              id: "onlyProviders"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.requestDTO.onlyProviders]
                            ]),
                            _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.helper.trans('labels.only_providers')), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[16] || (_cache[16] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[17] || (_cache[17] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                    ])
                  ])
                ]),
                (_ctx.isAdmin || _ctx.isOperator || _ctx.isMerchant || _ctx.isMerchantOperator || _ctx.isReferral)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      (_ctx.isAdmin || _ctx.isOperator || _ctx.isReferral)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("div", _hoisted_67, [
                                _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.helper.trans('labels.group_by')), 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "radio",
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.requestDTO.groupBy) = $event)),
                                  value: "store",
                                  class: "btn-check",
                                  name: "options-outlined",
                                  id: "group-stores",
                                  autocomplete: "off",
                                  checked: ""
                                }, null, 512), [
                                  [_vModelRadio, _ctx.requestDTO.groupBy]
                                ]),
                                _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.helper.trans('labels.stores')), 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "radio",
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.requestDTO.groupBy) = $event)),
                                  value: "trader",
                                  class: "btn-check",
                                  name: "options-outlined",
                                  id: "group-traders",
                                  autocomplete: "off"
                                }, null, 512), [
                                  [_vModelRadio, _ctx.requestDTO.groupBy]
                                ]),
                                _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.helper.trans('labels.traders')), 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "radio",
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.requestDTO.groupBy) = $event)),
                                  value: "provider",
                                  class: "btn-check",
                                  name: "options-outlined",
                                  id: "group-providers",
                                  autocomplete: "off"
                                }, null, 512), [
                                  [_vModelRadio, _ctx.requestDTO.groupBy]
                                ]),
                                _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.helper.trans('labels.providers')), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.reportTypeOptions.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                            _createElementVNode("div", _hoisted_73, [
                              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_74, [
                                _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fa-solid fa-download" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.download_detailed_report')), 1)
                              ])), [
                                [_directive_bs_dropdown_fixed]
                              ]),
                              _createElementVNode("ul", _hoisted_75, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportTypeOptions, (option) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: option.value
                                  }, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item text-capitalize-first",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (_ctx.onReportOptionClick(option)), ["prevent"])
                                    }, _toDisplayString(option.label), 9, _hoisted_76)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isAdmin || _ctx.isOperator)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                      (_ctx.isAdmin || _ctx.isOperator)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                            _createElementVNode("div", _hoisted_79, [
                              _createElementVNode("div", _hoisted_80, [
                                _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.helper.trans('labels.sort_by')), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderByFields, (field) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    class: _normalizeClass(["btn btn-sm me-2", {'btn-outline-dark': _ctx.orderBy.field !== field, 'btn-dark': _ctx.orderBy.field === field}]),
                                    onClick: _withModifiers(($event: any) => (_ctx.helper.toggleOrderBy(_ctx.orderBy, field)), ["prevent"]),
                                    key: field
                                  }, [
                                    _createTextVNode(_toDisplayString(_ctx.helper.trans(`labels.${field}`)) + " ", 1),
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.orderBy, field)])
                                    }, null, 2)
                                  ], 10, _hoisted_82))
                                }), 128)),
                                _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.helper.trans('labels.status')) + ":", 1),
                                _createElementVNode("div", _hoisted_84, [
                                  _createVNode(_component_Multiselect, {
                                    id: "order-by-status",
                                    class: "multiselect-sm multiselect-capitalize me-2",
                                    modelValue: _ctx.orderByStatus,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.orderByStatus) = $event)),
                                    options: _ctx.statuses,
                                    "custom-label": (opt) => _ctx.helper.trans(`deal_status.${opt}`),
                                    multiple: false,
                                    "select-label": "Select",
                                    placeholder: _ctx.helper.trans('labels.status')
                                  }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                                ]),
                                _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.helper.trans('labels.type')) + ":", 1),
                                _createElementVNode("div", _hoisted_86, [
                                  _createVNode(_component_Multiselect, {
                                    id: "order-by-direction",
                                    class: "multiselect-sm multiselect-capitalize",
                                    modelValue: _ctx.orderByType,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.orderByType) = $event)),
                                    options: Object.values(_ctx.Direction),
                                    "custom-label": (opt) => _ctx.helper.trans(`direction.${opt}`),
                                    multiple: false,
                                    "select-label": "Select",
                                    placeholder: _ctx.helper.trans('labels.type')
                                  }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("table", _hoisted_89, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedGroups, (group) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: group.groupId
                      }, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_90, [
                              (group.groupId === '0')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_91, _toDisplayString(_ctx.helper.trans('labels.total')), 1))
                                : _createCommentVNode("", true),
                              (group.store)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString(`${group.store?.merchantName} - ${group.store?.name}`), 1))
                                : _createCommentVNode("", true),
                              (group.trader)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_93, [
                                    _createTextVNode(_toDisplayString(group.trader?.name) + " ", 1),
                                    (group.trader?.email.length > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_94, "(" + _toDisplayString(group.trader?.email) + ")", 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.byDirections, (typeStat, type) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: type }, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_95, _toDisplayString(_ctx.helper.trans(`direction.${type}`)), 1)
                              ])
                            ]),
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", _hoisted_96, [
                                _createElementVNode("th", _hoisted_97, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
                                _createElementVNode("th", _hoisted_98, _toDisplayString(_ctx.helper.trans('labels.count')), 1),
                                _createElementVNode("th", _hoisted_99, _toDisplayString(_ctx.helper.trans('labels.taker_sum')), 1),
                                (_ctx.mainFields.includes('traders'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_100, _toDisplayString(type === _ctx.Direction.PAY_IN ? _ctx.helper.trans('labels.trader_sum_out') : _ctx.helper.trans('labels.trader_sum_in')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.showStoreRate)
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_101, _toDisplayString(_ctx.helper.trans('labels.store_rate_sum')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.mainFields.includes('stores'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_102, _toDisplayString(type === _ctx.Direction.PAY_IN ? _ctx.helper.trans('labels.store_sum_in') : _ctx.helper.trans('labels.store_sum_out')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.mainFields.includes('fee'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_103, _toDisplayString(_ctx.helper.trans('labels.store_fee_sum')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.rewardFields.length > 0)
                                  ? (_openBlock(), _createElementBlock("th", {
                                      key: 4,
                                      colspan: _ctx.rewardFields.length + (_ctx.rewardFields.includes('service') ? _ctx.partners.length + (_ctx.partners.length > 0 ? 1 : 0) : 0),
                                      class: "text-center p-0"
                                    }, _toDisplayString(_ctx.helper.trans('labels.rewards')), 9, _hoisted_104))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", _hoisted_105, [
                                (_ctx.rewardFields.includes('trader'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_106, _toDisplayString(_ctx.helper.trans('labels.trader')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.rewardFields.includes('teamlead'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_107, _toDisplayString(_ctx.helper.trans('labels.teamlead')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.rewardFields.includes('referral'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_108, _toDisplayString(_ctx.helper.trans('labels.referral')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.rewardFields.includes('service'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_109, _toDisplayString(_ctx.helper.trans('labels.service')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.rewardFields.includes('service'))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
                                        return (_openBlock(), _createElementBlock("th", _hoisted_110, _toDisplayString(partner.userName), 1))
                                      }), 256)),
                                      (_ctx.partners.length > 0)
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_111, _toDisplayString(_ctx.helper.trans('labels.rest_of')), 1))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("tbody", _hoisted_112, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: status }, [
                                  (typeStat[status])
                                    ? (_openBlock(), _createElementBlock("tr", {
                                        key: 0,
                                        class: _normalizeClass({'text-success': status === 'processed', 'text-danger' : status === 'rejected', 'text-secondary': !['processed', 'rejected', 'total', _ctx.DealStatus.COMPLETED].includes(status), 'small': !['processed', 'rejected', 'total',_ctx.DealStatus.COMPLETED].includes(status)})
                                      }, [
                                        _createElementVNode("td", _hoisted_113, _toDisplayString(_ctx.helper.trans(`deal_status.${status}`)), 1),
                                        _createElementVNode("td", _hoisted_114, [
                                          _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatNumber(typeStat[status].count)) + " ", 1),
                                          (status === 'rejected' || status === 'processed' || status === 'total' || status === _ctx.ACCEPTED_BY_TRADER_STATUS)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_115, " (" + _toDisplayString(_ctx.numberFormatter.formatNumber(group.countByDirections[type] ? typeStat[status].count/group.countByDirections[type] * 100 : 0, 1)) + "%) ", 1))
                                            : (status === 'completed_with_dispute')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_116, " (" + _toDisplayString(_ctx.numberFormatter.formatNumber((group.byDirections[type]['completed']?.count || 0) > 0 ? typeStat[status].count/(group.byDirections[type]['completed'].count) * 100 : 0, 1)) + "%) ", 1))
                                              : (status === 'completed_with_dispute_with_attach')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_117, " (" + _toDisplayString(_ctx.numberFormatter.formatNumber((group.byDirections[type]['completed']?.count || 0) > 0 ? typeStat[status].count/(group.byDirections[type]['completed'].count) * 100 : 0, 1)) + "%) ", 1))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_118, " (" + _toDisplayString(_ctx.numberFormatter.formatNumber(group.countByDirections[type] ? typeStat[status].count/group.countByDirections[type] * 100 : 0, 1)) + "% / " + _toDisplayString(_ctx.numberFormatter.formatNumber(group.dealsCountByDirections[type] ? typeStat[status].count/group.dealsCountByDirections[type] * 100 : 0, 1)) + "%) ", 1))
                                        ]),
                                        _createElementVNode("td", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeStat[status].takerSums, (sum, currency) => {
                                            return (_openBlock(), _createElementBlock("div", { key: currency }, _toDisplayString(_ctx.numberFormatter.formatMoney(sum)), 1))
                                          }), 128))
                                        ]),
                                        (_ctx.mainFields.includes('traders'))
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_119, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeStat[status].makerSums, (sum, currency) => {
                                                return (_openBlock(), _createElementBlock("div", { key: currency }, _toDisplayString(status !== _ctx.DealStatus.COMPLETED ? '' : type === _ctx.Direction.PAY_IN ? '-' : '+') + _toDisplayString(_ctx.numberFormatter.formatMoney(sum, _ctx.usdtSubunits)), 1))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.showStoreRate)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_120, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeStat[status].merchantMakerSums, (sum, currency) => {
                                                return (_openBlock(), _createElementBlock("div", { key: currency }, _toDisplayString(_ctx.numberFormatter.formatMoney(sum, _ctx.usdtSubunits)), 1))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.mainFields.includes('stores'))
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_121, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeStat[status].storeSums, (sum, currency) => {
                                                return (_openBlock(), _createElementBlock("div", { key: currency }, [
                                                  _createElementVNode("span", null, _toDisplayString(status !== _ctx.DealStatus.COMPLETED ? '' : type === _ctx.Direction.PAY_IN ? '+' : '-') + _toDisplayString(_ctx.numberFormatter.formatMoney(sum, _ctx.usdtSubunits)), 1)
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.mainFields.includes('fee'))
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_122, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeStat[status].storeFeeSums, (sum, currency) => {
                                                return (_openBlock(), _createElementBlock("div", { key: currency }, [
                                                  _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(sum, _ctx.usdtSubunits)) + " ", 1),
                                                  (_ctx.isAdmin && status === _ctx.DealStatus.COMPLETED && _ctx.feeBaseSums(typeStat[status])[currency] && _ctx.feeBaseSums(typeStat[status])[currency].amount != '0')
                                                    ? (_openBlock(), _createElementBlock("small", _hoisted_123, " (" + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(sum.amount)/parseFloat(_ctx.feeBaseSums(typeStat[status])[currency].amount) * 100, 1)) + "%) ", 1))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.rewardFields.includes('trader'))
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_124, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeStat[status].traderRewardSums, (sum, currency) => {
                                                return (_openBlock(), _createElementBlock("div", { key: currency }, [
                                                  _createTextVNode(_toDisplayString(status !== _ctx.DealStatus.COMPLETED ? '' : '+') + _toDisplayString(_ctx.numberFormatter.formatMoney(sum, _ctx.usdtSubunits)) + " ", 1),
                                                  (_ctx.isAdmin && status === _ctx.DealStatus.COMPLETED && typeStat[status].makerSums[currency] && typeStat[status].makerSums[currency].amount != '0')
                                                    ? (_openBlock(), _createElementBlock("small", _hoisted_125, " (" + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(sum.amount)/parseFloat(typeStat[status].makerSums[currency].amount) * 100, 1)) + "%) ", 1))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.rewardFields.includes('teamlead'))
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_126, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeStat[status].traderRefRewardSums, (sum, currency) => {
                                                return (_openBlock(), _createElementBlock("div", { key: currency }, [
                                                  _createTextVNode(_toDisplayString(status !== _ctx.DealStatus.COMPLETED ? '' : '+') + _toDisplayString(_ctx.numberFormatter.formatMoney(sum, _ctx.usdtSubunits)) + " ", 1),
                                                  (_ctx.isAdmin && status === _ctx.DealStatus.COMPLETED &&typeStat[status].makerSums[currency] && typeStat[status].makerSums[currency].amount != '0')
                                                    ? (_openBlock(), _createElementBlock("small", _hoisted_127, " (" + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(sum.amount)/parseFloat(typeStat[status].makerSums[currency].amount) * 100, 1)) + "%) ", 1))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.rewardFields.includes('referral'))
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_128, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeStat[status].merchantRefRewardSums, (sum, currency) => {
                                                return (_openBlock(), _createElementBlock("div", { key: currency }, [
                                                  _createTextVNode(_toDisplayString(status !== _ctx.DealStatus.COMPLETED ? '' : '+') + _toDisplayString(_ctx.numberFormatter.formatMoney(sum, _ctx.usdtSubunits)) + " ", 1),
                                                  (_ctx.isAdmin && status === _ctx.DealStatus.COMPLETED && typeStat[status].makerSums[currency] && typeStat[status].makerSums[currency].amount != '0')
                                                    ? (_openBlock(), _createElementBlock("small", _hoisted_129, " (" + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(sum.amount)/parseFloat(typeStat[status].makerSums[currency].amount) * 100, 1)) + "%) ", 1))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.rewardFields.includes('service'))
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_130, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeStat[status].serviceRewardSums, (sum, currency) => {
                                                return (_openBlock(), _createElementBlock("div", { key: currency }, [
                                                  _createTextVNode(_toDisplayString(status !== _ctx.DealStatus.COMPLETED ? '' : '+') + _toDisplayString(_ctx.numberFormatter.formatMoney(sum, _ctx.usdtSubunits)) + " ", 1),
                                                  (_ctx.isAdmin && status === _ctx.DealStatus.COMPLETED && typeStat[status].makerSums[currency] && typeStat[status].makerSums[currency].amount != '0')
                                                    ? (_openBlock(), _createElementBlock("small", _hoisted_131, " (" + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(sum.amount)/parseFloat(typeStat[status].makerSums[currency].amount) * 100, 1)) + "%) ", 1))
                                                    : _createCommentVNode("", true),
                                                  (typeStat[status].serviceAdditionalRewardSums[currency])
                                                    ? (_openBlock(), _createElementBlock("small", _hoisted_132, " (" + _toDisplayString(status !== _ctx.DealStatus.COMPLETED ? '' : '+') + _toDisplayString(_ctx.numberFormatter.formatMoney(typeStat[status].serviceAdditionalRewardSums[currency], _ctx.usdtSubunits)) + ") ", 1))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.rewardFields.includes('service'))
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
                                                return (_openBlock(), _createElementBlock("td", null, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeStat[status].partnersRewards[partner.userId], (sum, currency) => {
                                                    return (_openBlock(), _createElementBlock("div", { key: currency }, _toDisplayString(_ctx.numberFormatter.formatMoney(sum, _ctx.usdtSubunits)), 1))
                                                  }), 128))
                                                ]))
                                              }), 256)),
                                              (typeStat[status].partnersRewards[0])
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_133, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeStat[status].partnersRewards[0], (sum, currency) => {
                                                      return (_openBlock(), _createElementBlock("div", { key: currency }, _toDisplayString(_ctx.numberFormatter.formatMoney(sum, _ctx.usdtSubunits)), 1))
                                                    }), 128))
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ], 2))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ])
                          ], 64))
                        }), 128)),
                        _cache[24] || (_cache[24] = _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", { colspan: "20" })
                          ])
                        ], -1))
                      ], 64))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512)
    ]),
    _: 1
  }, 512))
}